import TrendGraph from "../trendGraph"



export default  ()=>{

	return <TrendGraph commentsGraph={true}/>
}